import { initExpandableInfoIcon } from './expandable-info-icon';

initExpandableInfoIcon({
  buttonSelector: '.b-featured-trays__info-button',
  titleSelector: '.b-featured-trays__title.has-info',
  showLabel: 'Show featured trays information',
  hideLabel: 'Hide featured trays information',
});
